import React from 'react';
import { Box, Skeleton, Grid } from '@mui/material';
import HorizontalDivider from './HorizontalDivider';

function SolicitudDeConexionSkeleton() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100vh',
        alignItems: 'center',
        justifyContent: 'flex-start'
      }}>
      <Box sx={{ position: 'absolute', left: '4rem', top: '3.5rem' }}>
        <Skeleton variant="text" width={'18vw'} height={'45vh'} animation="wave" />
      </Box>
      <Box
        sx={{
          position: 'absolute',
          top: '1rem',
          right: '5vw',
          display: 'flex',
          width: '67vw',
          marginTop: 'calc(3rem + 76px)',
          marginLeft: '4rem',
          flexDirection: 'column',
          gap: '1.5rem'
        }}>
        {/* Título */}
        <Box
          sx={{
            display: 'flex',
            gap: '0.5rem',
            alignItems: 'flex-start',
            flexDirection: 'column'
          }}>
          <Skeleton variant="text" width={250} height={40} animation="wave" />
          <Skeleton variant="text" width={800} height={40} animation="wave" />
        </Box>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '2vh' }}>
          {/* Primer Box */}
          <Grid container spacing={2}>
            {Array.from(Array(10)).map((_, index) => (
              <Grid item xs={6} sm={4} md={2} key={index}>
                <Skeleton
                  animation="wave"
                  variant="rectangular"
                  width="100%"
                  height={100} 
                  sx={{ borderRadius: '1rem' }}
                />
              </Grid>
            ))}
          </Grid>

          <HorizontalDivider />
          {/* Segundo Box */}
          <Skeleton
            animation="wave"
            variant="rectangular"
            width="100%"
            height="5vh"
            sx={{
              borderRadius: '1rem'
            }}
          />
        </Box>
      </Box>
      {/* Footer */}
      <Box
        sx={{
          position: 'absolute',
          bottom: '0',
          width: '100%',
          height: '7em',
          paddingY: '2em',
          paddingX: '4rem',
          gap: 2,
          justifyContent: 'flex-end',
          display: 'flex',
          flexDirection: 'row'
        }}>
        <Skeleton
          animation="wave"
          variant="rectangular"
          width={220}
          height={50}
          sx={{
            borderRadius: '1rem'
          }}
        />
        <Skeleton
          animation="wave"
          variant="rectangular"
          width={220}
          height={50}
          sx={{
            marginRight: '2rem',
            borderRadius: '1rem'
          }}
        />
      </Box>
    </Box>
  );
}

export default SolicitudDeConexionSkeleton;
